import {useContext} from 'react';
import {CubeContext} from '../AuthorizedApolloProvider'

const useCubeClient = () => useContext(CubeContext)

export default useCubeClient;
